
// Valores esperados por ambiente:
//   Dev  → PRODUCTION=false  | API_BASE_URL=/dev  | API_KEY=<key>
//   Prod → PRODUCTION=true   | API_BASE_URL=/prod | API_KEY=<key>
//
// O CloudFront encaminha /dev/* e /prod/* para o API Gateway,
// ocultando a URL real da AWS do navegador.
export const environment = {
  production: false,
  apiBaseUrl: 'https://smv01fuvxf.execute-api.us-east-1.amazonaws.com/dev',
  apiKey: 'e3a5b9c1d4f26a7b8c9d0e1f2a3b4c5d6e7f8091A8dvkkyvGh7M3AG3neR4t1onEvol1pLi5bEOuUN28c9d0e1f2a3b4c5d6e7f8091a2b3c4d5e6f7a8b9c0d1e2f3',
};
